import CountryCodes from "./countryCodes";
import { lowerCase } from "./lodash";

/**
 * Picking up only specific fields from object
 * @param {object}
 * @param {array / string} array/string that contains keys of the object
 * @returns returns the object with selected key
 */

export function copyKeys(data, path) {
  const x = {};
  (typeof path === "string" ? path.split(",") : path).map((k) => {
    x[k] = data[k];
    return x[k];
  });
  return x;
}

const getCountryCode = (country) =>
  CountryCodes.filter(
    (cobj) => lowerCase(cobj.name) === lowerCase(country)
  ).map((cobj) => cobj.dial_code);

/**
 * Appends the country code
 * @param {int/string} mobile
 * @param {string} country
 * @returns
 */

export const validateMobile = (mobile, country = "") => {
  const mobileNo = mobile.toString();
  const dialCode = country ? getCountryCode(country) : "+91";
  return `${dialCode}${mobileNo}`;
};
